import { useMutation, useQueryClient } from "@tanstack/react-query"
import { updateProductionStageStatus } from "@/lib/api/order.api"
import { useAuthStore } from "@/store/auth.store"

export function useUpdateProductionStageStatus(orderId: string) {
  const accessToken = useAuthStore((s) => s.accessToken)
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ stageId, status }: { stageId: string; status: "PENDING" | "IN_PROGRESS" | "COMPLETED" }) => {
      if (!accessToken) throw new Error("Not authenticated")
      return updateProductionStageStatus(orderId, stageId, status, accessToken)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["seller-order-detail", orderId] })
      queryClient.invalidateQueries({ queryKey: ["buyer-order-detail", orderId] })
      queryClient.invalidateQueries({ queryKey: ["admin-order-detail", orderId] })
    },
  })
}
